<template>
  <div class="page">
    <!-- 遮罩 -->
    <div class="mask"></div>

    <!-- 弹窗 -->
    <div class="popup">
      <!-- 弹窗内容 -->
      <div class="popup-content">
        <!-- 背景 -->
        <div class="content-bg">
          <img src="@/assets/images/YuliApp/AirdropPasscard/popup_bg.png" />
        </div>

        <!-- 文字内容 -->
        <div class="content-text">
          <div class="pos content-text-name longTouch">How Does It Work?</div>

          <div class="pos content-text-body">
            <div class="text">
              {{ `Each player stands a chance in obtaining one Passcard Ticket while purifying Terras.

                  Better Purification outcome will yield you a much higher odds of getting a Ticket.

                  Please be aware that the exclusive opportunity to secure a ticket lies solely through Yuli Purification. 
                  
                  One Passcard Ticket grants you one Passcard NFT.

                  After the event, we will airdrop and distribute these Passcard NFTs at a unified time based on the number of Tickets held by all user accounts.` }}
            </div> 
          </div>
        </div>
      </div>

      <!-- 弹窗按钮 -->
      <div class="popup-btn" @click="handleClose"></div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from "vue";
import hookStoreState from "@/utils/useState.js";
// import { PRIZE_LIST } from "../../constants/storagePrize.js";
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState({
      languageEnv: (state) => state.global.languageEnv,
      languagePackage: (state) => state.global.languagePackage,
    }),
  },
  watch: {
    languageEnv: {
      async handler(value) {
        if(value){
          this.localesEnv = value;
        }
      },
      immediate: true,
      deep: true,
    },
    languagePackage: {
      async handler(value) {
        if(value){
          this.localesPackage = value;
        }
      },
      immediate: true,
      deep: true,
    }
  },
  setup(props, ctx) {
    /**语言包 - ref */
    const localesPackage = ref({});
    /**语言环境 - ref */
    const localesEnv = ref('en');
    const storeStateObj = hookStoreState({
      init: (state) => state.global.init,
      statusBarHeight: (state) => state.global.statusBarHeight,
    });
    const { statusBarHeight } = storeStateObj;
    const popup_top = ref(
      statusBarHeight.value + window.innerHeight * 0.1 - 20
    );
    // const prize_list = ref([]);
    onMounted(() => {
      // prize_list.value = PRIZE_LIST;
    });

    /**
     * 处理关闭
     */
    const handleClose = () => {
      ctx.emit("close", false);
    };

    return {
      popup_top,
      handleClose,
      localesPackage,
      localesEnv
      // prize_list,
    };
  },
};
</script>

<style lang="less" scoped>
//阻止长按操作
.longTouch {
  -webkit-touch-callout: none; /*系统默认菜单被禁用*/
  -webkit-user-select: none; /*webkit浏览器*/
  -khtml-user-select: none; /*早期浏览器*/
  -moz-user-select: none; /*火狐*/
  -ms-user-select: none; /*IE10*/
  user-select: none;
}
.blod{
  font-weight: 600;
}
p {
  margin: 0;
  padding: 0;
}
.page {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 999;

  .mask {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    top: 0;
    left: 0;
  }

  .popup {
    width: 329px;
    // margin-top: 128px; // 84
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    img {
      width: 100%;
      height: 100%;
    }

    &-content {
      width: 100%;

      .content {
        &-bg {
          width: 329px;
          height: 385px;
        }

        &-text {
          color: #ffffff;
          font-size: 15px;
          font-weight: 400;
          font-family: "PingFang SC";
          text-align: left;
          
          .pos {
            position: absolute;
            left: 0;
            right: 0;
            margin: 0 auto;
          }

          &-name {
            top: 22px;
            font-size: 16px;
            font-weight: 600;
            text-align: center;
          }

          &-body {
            top: 60px;
            width: 241px;
            padding-left: 10px;
            font-size: 15px;
            line-height: 20px;
            overflow-y:scroll;
            height: 300px;
            color: #D3F7FF;
            white-space: pre-line;
            .text {
              margin-bottom: 22px;
              &-title {
                color: rgba(98, 110, 143, 1);
                font-size: 16px;
                font-weight: 600;
                font-family: "PingFang SC";
                text-align: left;
                line-height: 20px;
                margin-bottom: 3px;
              }
              &-content {
                // padding-left: 12px;
                color: rgba(98, 110, 143, 1);
                font-size: 14px;
                font-weight: 400;
                font-family: "PingFang SC";
                text-align: left;
                line-height: 20px;
              }
              p{
                  margin: 10px 0;
                }
            }
          }
        }
      }
    }

    &-btn {
      // margin-top: 28px;
      position: absolute;
      z-index: 999;
      top: 8px;
      right: 3px;
      width: 20px;
      height: 20px;
      // background-color: azure;
    }
  }
}
</style>
